import { Input, Directive } from '@angular/core';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';

@Directive()
export abstract class GiftcardsAddedGiftcardComponentDef {
    @Input()
    giftcard?: Giftcards.IAddedGiftcardData;

    @Input()
    isCheckout = false;

    @Input()
    useCheckoutPath = false;

    status = new Status();

    constructor(private request: RequestService) {}

    protected getPath(): string {
        return this.useCheckoutPath ? Giftcards.Endpoints.CheckoutRemove : Giftcards.Endpoints.Remove;
    }

    remove(): Promise<any> | void {
        if (this.giftcard && this.giftcard.code) {
            const data: Giftcards.IRemoveData = { code: this.giftcard.code };
            if (this.isCheckout) {
                data.checkout = true;
            }
            return this.request.send(this.status, { path: this.getPath(), data });
        }
    }
}
